import { Layout, LayoutProps, AppBar, AppBarProps, UserMenu, Logout, useGetIdentity } from 'react-admin';
import { Typography, Box, Avatar } from '@mui/material';

// RBAC Provider - must be inside Admin context
import { RBACProvider } from '../rbac';
// Admin Menu with permissions
import { AdminMenu } from './AdminMenu';

/**
 * Custom App Bar
 */
function EkaaAppBar(props: AppBarProps) {
  return (
    <AppBar {...props} color="primary">
      <Typography variant="h6" sx={{ flex: 1 }}>
        EKAA Admin
      </Typography>
    </AppBar>
  );
}


/**
 * Custom User Menu with identity display
 * Implémenté mais jamais câblé sur <Layout userMenu={...}> — pas du code mort à
 * supprimer, une fonctionnalité prête que quelqu'un a laissée en suspens. Ne pas
 * l'activer ici en passant (changerait l'UI admin sans que ce soit le sujet).
 * Exportée (au lieu du eslint-disable no-unused-vars précédent) : tsc
 * noUnusedLocals la signale sinon (TS6133) — l'eslint-disable ne couvrait que
 * la règle ESLint, pas le compilateur.
 */
export function EkaaUserMenu() {
  const { data: identity, isLoading } = useGetIdentity();

  if (isLoading) return null;

  return (
    <UserMenu>
      <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Avatar sx={{ width: 32, height: 32, bgcolor: 'secondary.main' }}>
          {identity?.fullName?.charAt(0) || 'A'}
        </Avatar>
        <Box>
          <Typography variant="body2" fontWeight={500}>
            {identity?.fullName || 'Admin'}
          </Typography>
        </Box>
      </Box>
      <Logout />
    </UserMenu>
  );
}

/**
 * EKAA Admin Layout with RBAC
 */
export function EkaaLayout(props: LayoutProps) {
  return (
    <RBACProvider>
      <Layout
        {...props}
        appBar={EkaaAppBar}
        menu={AdminMenu}
      />
    </RBACProvider>
  );
}

/**
 * Simple Layout without RBAC (for debugging)
 */
export function SimpleEkaaLayout(props: LayoutProps) {
  return (
    <Layout
      {...props}
      appBar={EkaaAppBar}
      menu={AdminMenu}
    />
  );
}
